/**
 * Toast notification constants
 */
export const TOAST_CONSTANTS = {
	/** Default delay in milliseconds before auto-hiding toast notifications */
	DEFAULT_DELAY: 5000,
} as const;
